import {useMemo} from 'preact/hooks';

import {I18N} from './types';
import {
  formatDate,
  formatExpiryTimeRemaining,
  formatDeliveryAddress,
  formatSingularHoursAndMinutes,
  translate,
} from './helpers';

export function useI18n() {
  return useMemo(
    () =>
      ({
        translate,
        formatSingularHoursAndMinutes,
        formatExpiryTimeRemaining,
        formatDate,
        formatDeliveryAddress,
      } as I18N),
    [],
  );
}
